// import React from "react";
// import {
//     Box, Typography, Button, CircularProgress, TextField, MenuItem,
//     Select, FormControl, Dialog, DialogTitle, DialogContent,
//     DialogActions, IconButton, Checkbox, FormControlLabel
// } from "@mui/material";
// import SearchIcon from '@mui/icons-material/Search';
// import CloseIcon from '@mui/icons-material/Close';

// const NAVY     = "#0D2137";
// const STEEL    = "#1B4FBB";
// const STEEL_LT = "#EBF2FF";
// const PAGE_BG  = "#F4F6F9";
// const BORDER   = "#E2E8F0";
// const TH_BG    = "#F7F9FC";
// const T1       = "#1A202C";
// const T2       = "#4A5568";
// const T3       = "#718096";
// const WHITE    = "#FFFFFF";

// const inputSx = {
//     "& .MuiOutlinedInput-root": {
//         borderRadius: "4px", background: WHITE, fontSize: 13, height: 36,
//         "& fieldset": { borderColor: BORDER },
//         "&:hover fieldset": { borderColor: STEEL },
//         "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 },
//     },
//     "& .MuiInputLabel-root": { fontSize: 13, color: T3 },
// };
// const btnPrimary = {
//     background: STEEL, color: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 600,
//     textTransform: "none", px: 2, height: 32, whiteSpace: "nowrap",
//     "&:hover": { background: "#1640A0" },
//     "&:disabled": { background: BORDER, color: T3 },
// };
// const btnGhost = {
//     background: "transparent", color: T2, border: `1px solid ${BORDER}`,
//     borderRadius: "4px", fontSize: 12, fontWeight: 500,
//     textTransform: "none", px: 1.5, height: 30, whiteSpace: "nowrap",
//     "&:hover": { background: PAGE_BG, color: T1 },
// };

// function FilterChip({ label }) {
//     return (
//         <Box sx={{ display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "3px", background: STEEL_LT, borderRadius: "20px" }}>
//             <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: STEEL }} />
//             <Typography sx={{ fontSize: 12, fontWeight: 500, color: STEEL }}>{label}</Typography>
//         </Box>
//     );
// }

// export default function StockReportFilterDialog({
//     open, onClose, loading,
//     tempReportType, handleTempReportTypeChange, reportOptions,
//     tempSelectedGroupIds, itemGroups, itemGroupsLoading,
//     handleSelectAllGroups, handleGroupToggle,
//     tempFromDate, setTempFromDate,
//     tempToDate, setTempToDate,
//     tempShowZeroRecords, setTempShowZeroRecords,
//     onGetData,
// }) {
//     return (
//         <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth
//             PaperProps={{ sx: { borderRadius: "6px", border: `1px solid ${BORDER}`, boxShadow: "0 12px 40px rgba(0,0,0,0.18)", overflow: "hidden" } }}>
//             <DialogTitle sx={{ p: 0 }}>
//                 <Box sx={{ background: NAVY, px: 2.5, py: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                     <Box>
//                         <Typography sx={{ fontSize: 14, fontWeight: 700, color: WHITE, lineHeight: 1 }}>Report Configuration</Typography>
//                         <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.5)", mt: "3px" }}>Set parameters to generate the stock report</Typography>
//                     </Box>
//                     <IconButton onClick={onClose} size="small"
//                         sx={{ color: "rgba(255,255,255,0.6)", "&:hover": { background: "rgba(255,255,255,0.1)" } }}>
//                         <CloseIcon sx={{ fontSize: 18 }} />
//                     </IconButton>
//                 </Box>
//             </DialogTitle>

//             <DialogContent sx={{ px: 2.5, pt: 2.5, pb: 1, background: WHITE }}>
//                 <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

//                     {/* Report Type */}
//                     <Box>
//                         <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", letterSpacing: ".5px", textTransform: "uppercase" }}>Report Type</Typography>
//                         <FormControl fullWidth size="small">
//                             <Select value={tempReportType} onChange={(e) => handleTempReportTypeChange(e.target.value)}
//                                 sx={{ borderRadius: "4px", fontSize: 13,
//                                     "& fieldset": { borderColor: BORDER },
//                                     "&:hover fieldset": { borderColor: STEEL },
//                                     "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 },
//                                     "& .MuiSelect-select": { fontSize: 13, py: "9px" },
//                                 }}>
//                                 {reportOptions.map((option) => (
//                                     <MenuItem key={option} value={option} sx={{ fontSize: 13 }}>{option}</MenuItem>
//                                 ))}
//                             </Select>
//                         </FormControl>
//                     </Box>

//                     {/* Groupwise selector */}
//                     {tempReportType === "Groupwise Item" && (
//                         <Box>
//                             <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", letterSpacing: ".5px", textTransform: "uppercase" }}>Select Groups</Typography>
//                             {itemGroupsLoading ? (
//                                 <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 1 }}>
//                                     <CircularProgress size={16} sx={{ color: STEEL }} />
//                                     <Typography sx={{ fontSize: 12, color: T3 }}>Loading groups...</Typography>
//                                 </Box>
//                             ) : (
//                                 <Box sx={{ border: `1px solid ${BORDER}`, borderRadius: "4px", maxHeight: 200, overflowY: "auto" }}>
//                                     <Box sx={{ display: "flex", alignItems: "center", px: 1, py: "4px", borderBottom: `1px solid ${BORDER}`, background: TH_BG, position: "sticky", top: 0, zIndex: 1 }}>
//                                         <Checkbox size="small"
//                                             checked={tempSelectedGroupIds.length === itemGroups.length && itemGroups.length > 0}
//                                             indeterminate={tempSelectedGroupIds.length > 0 && tempSelectedGroupIds.length < itemGroups.length}
//                                             onChange={handleSelectAllGroups}
//                                             sx={{ color: T3, "&.Mui-checked": { color: STEEL }, "&.MuiCheckbox-indeterminate": { color: STEEL }, p: "4px" }}
//                                         />
//                                         <Typography sx={{ fontSize: 12, fontWeight: 600, color: T2 }}>
//                                             Select All ({itemGroups.length})
//                                         </Typography>
//                                     </Box>
//                                     {itemGroups.length === 0 ? (
//                                         <Box sx={{ px: 2, py: 1.5 }}>
//                                             <Typography sx={{ fontSize: 12, color: T3 }}>No groups found</Typography>
//                                         </Box>
//                                     ) : (
//                                         itemGroups.map((group) => (
//                                             <Box key={group.ItemGrpID} onClick={() => handleGroupToggle(group.ItemGrpID)}
//                                                 sx={{ display: "flex", alignItems: "center", px: 1, py: "3px", cursor: "pointer", "&:hover": { background: STEEL_LT }, borderBottom: `1px solid ${BORDER}` }}>
//                                                 <Checkbox size="small" checked={tempSelectedGroupIds.includes(group.ItemGrpID)}
//                                                     onChange={() => handleGroupToggle(group.ItemGrpID)} onClick={(e) => e.stopPropagation()}
//                                                     sx={{ color: BORDER, "&.Mui-checked": { color: STEEL }, p: "4px" }} />
//                                                 <Typography sx={{ fontSize: 13, color: T1 }}>{group.GroupName}</Typography>
//                                             </Box>
//                                         ))
//                                     )}
//                                 </Box>
//                             )}
//                             {tempSelectedGroupIds.length > 0 && (
//                                 <Box sx={{ display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "3px", mt: "6px", background: NAVY, borderRadius: "3px" }}>
//                                     <Typography sx={{ fontSize: 12, fontWeight: 500, color: WHITE }}>
//                                         {tempSelectedGroupIds.length} group{tempSelectedGroupIds.length > 1 ? "s" : ""} selected
//                                     </Typography>
//                                 </Box>
//                             )}
//                         </Box>
//                     )}

//                     {/* Date fields side by side */}
//                     <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5 }}>
//                         <Box>
//                             <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", letterSpacing: ".5px", textTransform: "uppercase" }}>From Date</Typography>
//                             <TextField type="date" fullWidth size="small" value={tempFromDate} onChange={(e) => setTempFromDate(e.target.value)} sx={inputSx} />
//                         </Box>
//                         <Box>
//                             <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", letterSpacing: ".5px", textTransform: "uppercase" }}>To Date</Typography>
//                             <TextField type="date" fullWidth size="small" value={tempToDate} onChange={(e) => setTempToDate(e.target.value)} sx={inputSx} />
//                         </Box>
//                     </Box>

//                     {/* Show zero records */}
//                     <Box sx={{ background: TH_BG, border: `1px solid ${BORDER}`, borderRadius: "4px", px: "14px", py: "10px" }}>
//                         <FormControlLabel
//                             control={
//                                 <Checkbox checked={tempShowZeroRecords} onChange={(e) => setTempShowZeroRecords(e.target.checked)}
//                                     size="small" sx={{ color: BORDER, "&.Mui-checked": { color: STEEL }, p: "2px", mt: "1px" }} />
//                             }
//                             label={
//                                 <Box>
//                                     <Typography sx={{ fontSize: 13, fontWeight: 500, color: T1, lineHeight: 1.3 }}>Include zero-movement items</Typography>
//                                     <Typography sx={{ fontSize: 11, color: T3, mt: "2px", lineHeight: 1.4 }}>Show items where Op. Balance, Inward &amp; Outward are all zero</Typography>
//                                 </Box>
//                             }
//                             sx={{ m: 0, alignItems: "flex-start" }}
//                         />
//                     </Box>

//                     {/* Selection preview */}
//                     {tempFromDate && tempToDate && (
//                         <Box sx={{ background: TH_BG, border: `1px solid ${BORDER}`, borderRadius: "4px", p: "10px 14px" }}>
//                             <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", textTransform: "uppercase", letterSpacing: ".5px" }}>Preview</Typography>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
//                                 <FilterChip label={tempReportType} />
//                                 <FilterChip label={`${tempFromDate} – ${tempToDate}`} />
//                                 {tempReportType === "Groupwise Item" && tempSelectedGroupIds.length > 0 && (
//                                     <FilterChip label={`${tempSelectedGroupIds.length} group${tempSelectedGroupIds.length > 1 ? "s" : ""}`} />
//                                 )}
//                                 {tempShowZeroRecords && <FilterChip label="Zero items: shown" />}
//                             </Box>
//                         </Box>
//                     )}
//                 </Box>
//             </DialogContent>

//             <DialogActions sx={{ px: 2.5, py: 2, gap: 1, borderTop: `1px solid ${BORDER}`, background: TH_BG }}>
//                 <Button onClick={onClose} sx={{ ...btnGhost, height: 34 }} fullWidth>Cancel</Button>
//                 <Button onClick={onGetData} disabled={loading}
//                     startIcon={loading ? <CircularProgress size={13} sx={{ color: WHITE }} /> : <SearchIcon sx={{ fontSize: 15 }} />}
//                     sx={{ ...btnPrimary, height: 34 }} fullWidth>
//                     Generate Report
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );
// }









import React, { useEffect } from "react";
import {
    Box, Typography, Button, CircularProgress, TextField, MenuItem,
    Select, FormControl, Dialog, DialogTitle, DialogContent,
    DialogActions, IconButton, Checkbox, FormControlLabel
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

const NAVY     = "#0D2137";
const STEEL    = "#1B4FBB";
const STEEL_LT = "#EBF2FF";
const PAGE_BG  = "#F4F6F9";
const BORDER   = "#E2E8F0";
const TH_BG    = "#F7F9FC";
const T1       = "#1A202C";
const T2       = "#4A5568";
const T3       = "#718096";
const WHITE    = "#FFFFFF";

const inputSx = {
    "& .MuiOutlinedInput-root": {
        borderRadius: "4px", background: WHITE, fontSize: 13, height: 36,
        "& fieldset": { borderColor: BORDER },
        "&:hover fieldset": { borderColor: STEEL },
        "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 },
    },
    "& .MuiInputLabel-root": { fontSize: 13, color: T3 },
};
const btnPrimary = {
    background: STEEL, color: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 600,
    textTransform: "none", px: 2, height: 32, whiteSpace: "nowrap",
    "&:hover": { background: "#1640A0" },
    "&:disabled": { background: BORDER, color: T3 },
};
const btnGhost = {
    background: "transparent", color: T2, border: `1px solid ${BORDER}`,
    borderRadius: "4px", fontSize: 12, fontWeight: 500,
    textTransform: "none", px: 1.5, height: 30, whiteSpace: "nowrap",
    "&:hover": { background: PAGE_BG, color: T1 },
};

const getFinancialYearDates = () => {
    const today = new Date();
    const yr = today.getFullYear();
    const fyStart = new Date(yr, 3, 2);
    if (today < fyStart) fyStart.setFullYear(yr - 1);
    const fyEnd = new Date(fyStart.getFullYear() + 1, 2, 32);
    return { fromDate: fyStart.toISOString().split("T")[0], toDate: fyEnd.toISOString().split("T")[0] };
};

function FilterChip({ label }) {
    return (
        <Box sx={{ display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "3px", background: STEEL_LT, borderRadius: "20px" }}>
            <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: STEEL }} />
            <Typography sx={{ fontSize: 12, fontWeight: 500, color: STEEL }}>{label}</Typography>
        </Box>
    );
}

export default function StockReportFilterDialog({
    open, onClose, loading,
    tempReportType, handleTempReportTypeChange, reportOptions,
    tempSelectedGroupIds, itemGroups, itemGroupsLoading,
    handleSelectAllGroups, handleGroupToggle,
    tempFromDate, setTempFromDate,
    tempToDate, setTempToDate,
    tempShowZeroRecords, setTempShowZeroRecords,
    onGetData,
}) {
    useEffect(() => {
        if (open) {
            const fy = getFinancialYearDates();
            setTempFromDate(fy.fromDate);
            setTempToDate(fy.toDate);
        }
    }, [open, setTempFromDate, setTempToDate]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth
            PaperProps={{ sx: { borderRadius: "6px", border: `1px solid ${BORDER}`, boxShadow: "0 12px 40px rgba(0,0,0,0.18)", overflow: "hidden" } }}>
            <DialogTitle sx={{ p: 0 }}>
                <Box sx={{ background: NAVY, px: 2.5, py: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Box>
                        <Typography sx={{ fontSize: 14, fontWeight: 700, color: WHITE, lineHeight: 1 }}>Report Configuration</Typography>
                        <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.5)", mt: "3px" }}>Set parameters to generate the stock report</Typography>
                    </Box>
                    <IconButton onClick={onClose} size="small"
                        sx={{ color: "rgba(255,255,255,0.6)", "&:hover": { background: "rgba(255,255,255,0.1)" } }}>
                        <CloseIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent sx={{ px: 2.5, pt: 2.5, pb: 1, background: WHITE }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

                    {/* Report Type */}
                    <Box>
                        <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", letterSpacing: ".5px", textTransform: "uppercase" }}>Report Type</Typography>
                        <FormControl fullWidth size="small">
                            <Select disabled value={tempReportType} onChange={(e) => handleTempReportTypeChange(e.target.value)}
                                sx={{ borderRadius: "4px", fontSize: 13,
                                    "& fieldset": { borderColor: BORDER },
                                    "&:hover fieldset": { borderColor: STEEL },
                                    "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 },
                                    "& .MuiSelect-select": { fontSize: 13, py: "9px" },
                                }}>
                                {reportOptions.map((option) => (
                                    <MenuItem key={option} value={option} sx={{ fontSize: 13 }}>{option}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>

                    {/* Groupwise selector */}
                    {tempReportType === "Groupwise Item" && (
                        <Box>
                            <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", letterSpacing: ".5px", textTransform: "uppercase" }}>Select Groups</Typography>
                            {itemGroupsLoading ? (
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 1 }}>
                                    <CircularProgress size={16} sx={{ color: STEEL }} />
                                    <Typography sx={{ fontSize: 12, color: T3 }}>Loading groups...</Typography>
                                </Box>
                            ) : (
                                <Box sx={{ border: `1px solid ${BORDER}`, borderRadius: "4px", maxHeight: 200, overflowY: "auto" }}>
                                    <Box sx={{ display: "flex", alignItems: "center", px: 1, py: "4px", borderBottom: `1px solid ${BORDER}`, background: TH_BG, position: "sticky", top: 0, zIndex: 1 }}>
                                        <Checkbox size="small"
                                            checked={tempSelectedGroupIds.length === itemGroups.length && itemGroups.length > 0}
                                            indeterminate={tempSelectedGroupIds.length > 0 && tempSelectedGroupIds.length < itemGroups.length}
                                            onChange={handleSelectAllGroups}
                                            sx={{ color: T3, "&.Mui-checked": { color: STEEL }, "&.MuiCheckbox-indeterminate": { color: STEEL }, p: "4px" }}
                                        />
                                        <Typography sx={{ fontSize: 12, fontWeight: 600, color: T2 }}>
                                            Select All ({itemGroups.length})
                                        </Typography>
                                    </Box>
                                    {itemGroups.length === 0 ? (
                                        <Box sx={{ px: 2, py: 1.5 }}>
                                            <Typography sx={{ fontSize: 12, color: T3 }}>No groups found</Typography>
                                        </Box>
                                    ) : (
                                        itemGroups.map((group) => (
                                            <Box key={group.ItemGrpID} onClick={() => handleGroupToggle(group.ItemGrpID)}
                                                sx={{ display: "flex", alignItems: "center", px: 1, py: "3px", cursor: "pointer", "&:hover": { background: STEEL_LT }, borderBottom: `1px solid ${BORDER}` }}>
                                                <Checkbox size="small" checked={tempSelectedGroupIds.includes(group.ItemGrpID)}
                                                    onChange={() => handleGroupToggle(group.ItemGrpID)} onClick={(e) => e.stopPropagation()}
                                                    sx={{ color: BORDER, "&.Mui-checked": { color: STEEL }, p: "4px" }} />
                                                <Typography sx={{ fontSize: 13, color: T1 }}>{group.GroupName}</Typography>
                                            </Box>
                                        ))
                                    )}
                                </Box>
                            )}
                            {tempSelectedGroupIds.length > 0 && (
                                <Box sx={{ display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "3px", mt: "6px", background: NAVY, borderRadius: "3px" }}>
                                    <Typography sx={{ fontSize: 12, fontWeight: 500, color: WHITE }}>
                                        {tempSelectedGroupIds.length} group{tempSelectedGroupIds.length > 1 ? "s" : ""} selected
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    )}

                    {/* Date fields side by side */}
                    <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5 }}>
                        <Box>
                            <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", letterSpacing: ".5px", textTransform: "uppercase" }}>From Date</Typography>
                            <TextField type="date" fullWidth size="small" value={tempFromDate} onChange={(e) => setTempFromDate(e.target.value)} sx={inputSx} />
                        </Box>
                        <Box>
                            <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", letterSpacing: ".5px", textTransform: "uppercase" }}>To Date</Typography>
                            <TextField type="date" fullWidth size="small" value={tempToDate} onChange={(e) => setTempToDate(e.target.value)} sx={inputSx} />
                        </Box>
                    </Box>

                    {/* Show zero records */}
                    <Box sx={{ background: TH_BG, border: `1px solid ${BORDER}`, borderRadius: "4px", px: "14px", py: "10px" }}>
                        <FormControlLabel
                            control={
                                <Checkbox checked={tempShowZeroRecords} onChange={(e) => setTempShowZeroRecords(e.target.checked)}
                                    size="small" sx={{ color: BORDER, "&.Mui-checked": { color: STEEL }, p: "2px", mt: "1px" }} />
                            }
                            label={
                                <Box>
                                    <Typography sx={{ fontSize: 13, fontWeight: 500, color: T1, lineHeight: 1.3 }}>Include zero-movement items</Typography>
                                    <Typography sx={{ fontSize: 11, color: T3, mt: "2px", lineHeight: 1.4 }}>Show items where Op. Balance, Inward &amp; Outward are all zero</Typography>
                                </Box>
                            }
                            sx={{ m: 0, alignItems: "flex-start" }}
                        />
                    </Box>

                    {/* Selection preview */}
                    {tempFromDate && tempToDate && (
                        <Box sx={{ background: TH_BG, border: `1px solid ${BORDER}`, borderRadius: "4px", p: "10px 14px" }}>
                            <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", textTransform: "uppercase", letterSpacing: ".5px" }}>Preview</Typography>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                                <FilterChip label={tempReportType} />
                                <FilterChip label={`${tempFromDate} – ${tempToDate}`} />
                                {tempReportType === "Groupwise Item" && tempSelectedGroupIds.length > 0 && (
                                    <FilterChip label={`${tempSelectedGroupIds.length} group${tempSelectedGroupIds.length > 1 ? "s" : ""}`} />
                                )}
                                {tempShowZeroRecords && <FilterChip label="Zero items: shown" />}
                            </Box>
                        </Box>
                    )}
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 2.5, py: 2, gap: 1, borderTop: `1px solid ${BORDER}`, background: TH_BG }}>
                <Button onClick={onClose} sx={{ ...btnGhost, height: 34 }} fullWidth>Cancel</Button>
                <Button onClick={onGetData} disabled={loading}
                    startIcon={loading ? <CircularProgress size={13} sx={{ color: WHITE }} /> : <SearchIcon sx={{ fontSize: 15 }} />}
                    sx={{ ...btnPrimary, height: 34 }} fullWidth>
                    Generate Report
                </Button>
            </DialogActions>
        </Dialog>
    );
}
